import React, { useState } from 'react';
import { View, StyleSheet, Text } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { useDispatch } from 'react-redux';
import Colors from '../../../../constants/Colors';
import Style from '../../../../constants/Style';
import RightArrow from '../../../16pxIcons/RightArrow';
import LeftArrow from '../../../16pxIcons/LeftArrow';
import {
  updateTicketsFilterAssetId, updateTicketsFilterAssetName,
} from '../../../../redux/ticketsFilterSlice';
import { AssetInstance } from '../../../../constants/Types';
import PressableStyled from '../../../PressableStyled';
import { AppScreen } from '../../../../navigation/LinkingConfiguration';

const rangeTitles: [string, string, string, string] = ['DAY', 'WEEK', 'MONTH', 'YEAR'];

interface TicketsRaisedSectionProps {
  ticketCounts: [number, number, number, number],
  asset: AssetInstance,
}

const TicketsRaisedSection = ({ ticketCounts, asset }: TicketsRaisedSectionProps) => {
  const [rangeIndex, setRangeIndex] = useState<number>(0);
  const navigation = useNavigation();
  const dispatch = useDispatch();

  const navigateToTickets = () => {
    dispatch(updateTicketsFilterAssetId(asset.id));
    dispatch(updateTicketsFilterAssetName(asset.name));
    let selectedPeriod = 'day';
    if (rangeTitles[rangeIndex] === 'WEEK') selectedPeriod = 'week';
    if (rangeTitles[rangeIndex] === 'MONTH') selectedPeriod = 'month';
    if (rangeTitles[rangeIndex] === 'YEAR') selectedPeriod = 'year';
    navigation.navigate(AppScreen.TICKETS as any, {
      selectedTimePeriod: selectedPeriod,
      assetId: asset.id,
    });
  };

  return <View style={styles.container}>
    <Text style={styles.title}>{'Tickets raised against asset'}</Text>
    <View style={styles.content}>
      <View style={styles.circle}>
        <Text style={styles.count}>{ticketCounts[rangeIndex]}</Text>
        <PressableStyled onPress={navigateToTickets}>
          <Text style={styles.rangeTitle}>{'View log'}</Text>
        </PressableStyled>
      </View>
      <View style={[Style.row, styles.rangeSection]}>
        <PressableStyled
          style={[styles.button, { opacity: rangeIndex < 1 ? 0 : 1 }]}
          onPress={() => setRangeIndex(Math.max(0, rangeIndex - 1))}
          disabled={rangeIndex < 1}
        >
          <LeftArrow color={Colors.light.hereworksBlue400} />
        </PressableStyled>
        <Text style={styles.rangeTitle}>{rangeTitles[rangeIndex]}</Text>
        <PressableStyled
          style={[styles.button, { opacity: rangeIndex > 2 ? 0 : 1 }]}
          onPress={() => setRangeIndex(Math.min(3, rangeIndex + 1))}
          disabled={rangeIndex > 2}
        >
          <RightArrow color={Colors.light.hereworksBlue400} />
        </PressableStyled>
      </View>
    </View>
  </View>;
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    marginHorizontal: 24,
    marginTop: 20,
  },
  title: {
    fontFamily: 'Poppins_500Medium',
    fontSize: 21,
    lineHeight: 30,
    color: Colors.light.hereworksBlack600,
    alignSelf: 'center',
    textAlign: 'center',
    marginBottom: 16,
  },
  content: {
    borderWidth: 1,
    borderRadius: 12,
    borderColor: Colors.light.hereworksBlue200,
    alignItems: 'center',
  },
  circle: {
    width: 140,
    height: 140,
    borderRadius: 70,
    borderWidth: 4,
    borderColor: Colors.light.hereworksBlue500,
    marginTop: 16,
    marginBottom: 24,
    justifyContent: 'center',
    alignItems: 'center',
  },
  count: {
    fontSize: 48,
    lineHeight: 72,
    fontFamily: 'Poppins_600SemiBold',
    color: Colors.light.hereworksBlue500,
  },
  rangeSection: {
    borderTopColor: Colors.light.hereworksBlue200,
    borderTopWidth: 1,
    alignSelf: 'stretch',
    padding: 12,
  },
  button: {
    height: 32,
    width: 32,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: Colors.light.hereworksBlue400,
    justifyContent: 'center',
    alignItems: 'center',
  },
  rangeTitle: {
    fontSize: 14,
    lineHeight: 21,
    fontFamily: 'Roboto_400Regular',
    color: Colors.light.hereworksBlue400,
  },
});

export default TicketsRaisedSection;
